import React, { Component, PropTypes } from 'react';
import Image from '../../components/image/image';
import { DateFormatter } from '../../utils/date';
import Pixeltext from '../../components/svg/pixeltext';
import axios from 'axios';
import css from './hof.scss';
import { profilesRoute } from '../../routes/index';
import { Link } from 'react-router';

import {uniqueId} from 'lodash';

import baseUrl from '../../utils/baseUrl';
let url = baseUrl + '/api/hof';

export default class HofProfile extends Component {
	static propTypes = {};
	
	constructor(props) {
		super(props);

		this.state = {
			active: false,
		};
	}

	render() {
		let profile = this.props.profile;
		let createdDate = new DateFormatter(profile.hofSince);
		let charNum = 285;
		let w = this.props.browser.window.width;

		if (w < 1441) {
			charNum = 230;
		}

		if (w < 1201) {
			charNum = 97;
		}

		if (w < 1000) {
			charNum = 74;
		}

		if (w < 720) {
			charNum = 170;
		}

		if (w < 568) {
			charNum = 90;
		}

		let truncated = profile.hofText.substr(0, charNum);

		//re-trim if we are in the middle of a word
		truncated = truncated.substr(0, Math.min(truncated.length, truncated.lastIndexOf(' ')));


		return (
			<li key={this.props.uid} className='hof__interview'>
				{profile.logoHoF.normal && (
				<div className='hof__interview__image-holder span5 span14-mobile'>
					<img className='hof__interview__image' {...profile.logoHoF.normal} />
				</div>
				)}
				<div className='hof__interview__buttons-container span5 span14-mobile'>
					<Link to={profilesRoute(profile.slug)} className='hof__interview__button button button--light-to-dark-anim button--go'>Agency profile</Link>
				</div>
				<div className='hof__interview__date span2 pixel-pattern hide-tablet hide-mobile'>
					<Pixeltext text={createdDate.date} className='hof__interview__day' y='5px' textAnchor='end'/>
					<span className='hof__interview__month'>{createdDate.month + ' ' + createdDate.year}</span>
					<span className='hof__interview__award'>BECAME MEMBER —</span>
				</div>
				<div className='hof__interview__right span7 span9-tablet span14-mobile'>
					<h4 className='hof__interview__byline'>By Rob Ford</h4>
					<h4 className='hof__interview__small-date hide-desktop'>{createdDate.date + ' ' + createdDate.month + ', ' + createdDate.year}</h4>
					<div className='hof__interview__content'>
						<h3 className='hof__interview__title'>{profile.name}</h3>
						{!this.state.active && (
						<p className='hof__interview__text span6 span12-mobile hof__interview__text--more'>{truncated} <a className='hof__interview__more button' onClick={(event) => this.moreClick(event)} href="#">...</a></p>
						) || (
						<p className='hof__interview__text span6 span12-mobile'>{profile.hofText} <a className='hof__interview__more button' onClick={(event) => this.moreClick(event)} href="#">...</a></p>
						)}
					</div>
				</div>
			</li>
		);
	}

	moreClick(e) {
		e.preventDefault();
		this.setState({
			active: !this.state.active,
		});
		
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/hof/profile.js
 **/